import React from "react";
import { Link } from "react-router-dom";
import { Foto, Imóvel } from "smart-imob-types";
import { PropertyLink, toBRL } from "../../utils/util_functions";
import Slider from "react-slick";
import styled from "styled-components";

const HorizontalImovelStyled = styled.div`
  .single-feature {
    align-items: center;
  }
  .slider-container {
    display: block;
    width: 40%;
    .slick-slide > div {
      min-height: 224px;
      max-height: 224px;
      .thumb {
        max-height: 224px;
      }
    }
    .slick-dots {
      bottom: 0;
      li button:before {
        font-size: 32px;
      }
    }
    .image-container {
      width: 100%;
    }
  }
  .details {
    align-self: stretch;
  }
  &:hover {
    .slider-container .image-container img {
      transform: scale(1);
    }
  }
  @media screen and (max-width: 575px) {
    .slider-container {
      width: 100%;
    }
  }
`;

type ImovelHorizontalProps = {
  imovel: Imóvel;
};
function ImovelHorizontal(props: ImovelHorizontalProps) {
  const { imovel } = props;

  let fotoDestaque =
    imovel.fotos && imovel.fotos.find(e => e.destaque === true);
  let SortedFotos = imovel.fotos
    ? imovel.fotos.sort(
        (a, b) =>
          a.destaque
            ? -1
            : parseInt(String(a.ordem)) - parseInt(String(b.ordem))
      )
    : [];
  // let imgSrc;
  // try {
  //   imgSrc = fotoDestaque
  //     ? fotoDestaque.resized || fotoDestaque.source.uri
  //     : SortedFotos[0].resized || SortedFotos[0].source.uri;
  // } catch (_) {
  //   imgSrc = "";
  // }

  const fotos: string[] = [];
  SortedFotos.splice(3, Infinity);
  SortedFotos.forEach((foto: Foto) =>
    fotos.push(foto.resized || foto.source.uri)
  );

  if (SortedFotos.length === 0) {
    fotos.push(
      "https://firebasestorage.googleapis.com/v0/b/smartimob-dev-test.appspot.com/o/placeholders%2Fproperty-placeholder.png?alt=media&token=96ef2786-f47a-484c-aa76-82880bd20b01"
    );
  }
  // fotoDestaque
  // ? fotos.push(fotoDestaque.resized || fotoDestaque.source.uri)
  // : fotos.push(SortedFotos[0].resized || SortedFotos[0].source.uri)
  // fotos.push(SortedFotos[1].resized || SortedFotos[1].source.uri)
  // fotos.push(SortedFotos[2].resized || SortedFotos[2].source.uri)

  let link = PropertyLink(imovel);
  let settings = {
    dots: true,
    arrows: true
  };
  try {
    return (
      <HorizontalImovelStyled>
        <div className="single-feature style-two">
          <div className="slider-container">
            <Slider {...settings}>
              {fotos.map(foto => (
                <div className="image-container">
                  <Link to={link} target="_blank" className="thumb">
                    {imovel.vendido && (
                      <span className="tag-vendido">Vendido</span>
                    )}
                    {imovel.alugado && (
                      <span className="tag-vendido">Alugado</span>
                    )}
                    <span className="tag-codigo">{imovel.codigo}</span>
                    <img
                      src={foto}
                      alt={`Imagem do imóvel #${imovel.codigo}`}
                    />
                  </Link>
                </div>
              ))}
            </Slider>
          </div>
          <div className="details">
            <div className="details-wrap">
              <h6 className="title readeal-top">
                <Link to={link} target="_blank">
                  {imovel.titulo ||
                    `${imovel.tipo || "Imóvel"} #${imovel.codigo}`}
                </Link>
              </h6>
              {imovel.venda &&
                (imovel.venda_exibir_valor_no_site === undefined ||
                  imovel.venda_exibir_valor_no_site === true) &&
                imovel.preço_venda > 0 && (
                  <h6 className="price">
                    Valor de venda:{" "}
                    {toBRL(Number(imovel.preço_venda), imovel.moeda)}
                  </h6>
                )}
              {imovel.locação &&
                (imovel.locação_exibir_valor_no_site === undefined ||
                  imovel.locação_exibir_valor_no_site === true) &&
                imovel.preço_locação > 0 && (
                  <h6 className="price">
                    Valor de locação:{" "}
                    {toBRL(Number(imovel.preço_locação), imovel.moeda)}
                    /mês
                  </h6>
                )}
              <ul className="info-list">
                {imovel.dormitórios && imovel.dormitórios !== "0" ? (
                  <li>
                    <i className="fa fa-bed" />
                    {imovel.dormitórios} Dorm.
                  </li>
                ) : imovel.suítes && imovel.suítes !== "0" ? (
                  <li>
                    <i className="fa fa-bed" />
                    {imovel.suítes} Suítes
                  </li>
                ) : null}
                {imovel.banheiros && imovel.banheiros !== "0" ? (
                  <li>
                    <i className="fa fa-bath" />
                    {imovel.banheiros || 0} Banh.
                  </li>
                ) : null}
                {imovel.vagas && imovel.vagas !== "0" ? (
                  <li>
                    <i className="fa fa-car" />
                    {imovel.vagas || 0} Vagas
                  </li>
                ) : null}
                {!!Number(
                  imovel.area_total || imovel.area_útil || imovel.area_privativa
                ) && (
                  <li>
                    <i className={"fa fa-expand"} />{" "}
                    {imovel.area_total
                      ? imovel.area_total + (imovel.tipo_area_total || "m²")
                      : imovel.area_útil
                        ? imovel.area_útil + (imovel.tipo_area_útil || "m²")
                        : imovel.area_privativa +
                          (imovel.tipo_area_privativa || "m²")}
                  </li>
                )}
              </ul>
              <ul className="contact-list">
                {
                  //<li style={{cursor: 'pointer'}}><span className="phone"><i className="fa fa-share"/></span></li>
                }
                <li className="readeal-top">
                  <Link className="btn btn-yellow" to={link} target="_blank">
                    Ver detalhes
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </HorizontalImovelStyled>
    );
  } catch (error) {
    console.log("ImovelHorizontal", error);
    return null;
  }
}

export default ImovelHorizontal;
